import Component from '@glimmer/component';
import { or } from 'tio-ui/utilities';
import { t } from 'ember-intl';

interface TuitionAssistanceProgramTemplateReviewApprovalWorkflowApprovalAttachmentsReviewSignature {
  Args: {
    // TODO: Is this a known model?
    attachmentData: {
      required: boolean;
      visible: boolean;
      text: string;
      values: string[];
    };
  };
}

export default class TuitionAssistanceProgramTemplateReviewApprovalWorkflowApprovalAttachmentsReviewComponent extends Component<TuitionAssistanceProgramTemplateReviewApprovalWorkflowApprovalAttachmentsReviewSignature> {
  isTrueOrFalse(value: boolean) {
    return value ? 'Yes' : 'No';
  }

  <template>
    <div class="col-span-3">
      {{#if (or @attachmentData.text @attachmentData.values)}}
        <p class="tio-text-sm-semibold uppercase">
          {{t "common.attachment_requirements"}}
        </p>
        <p class="my-2">{{@attachmentData.text}}</p>
        <ul class="list-inside list-disc">
          {{#each @attachmentData.values as |item|}}
            <li class="my-2 w-full ml-4">{{item}}</li>
          {{/each}}
        </ul>
      {{else}}
        <p class="tio-text-sm-semibold uppercase">
          {{t "common.attachment_requirements"}}
        </p>
        <p class="text-sm my-2">{{t "common.none"}}</p>
      {{/if}}
      <p class="font-semibold">{{t
          "common.tuition_assistance.program_template_review.visible_to_employees"
        }}:
        <span class="font-normal">{{this.isTrueOrFalse @attachmentData.visible}}</span></p>
      <p class="font-semibold">{{t "common.required"}}:
        <span class="font-normal">{{this.isTrueOrFalse @attachmentData.required}}</span></p>
    </div>
  </template>
}
